"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const form_radio_styled_1 = require("./form-radio.styled");
exports.FormRadio = ({ onChange, name, value, checked, label, alignment, children }) => {
    const id = `${name}-${value}`;
    const className = `radio radio--${checked ? 'checked' : 'unchecked'} radio--${name} radio--${id}`;
    const handler = onChange || ((e) => e.preventDefault());
    return React.createElement(form_radio_styled_1.StyledFormRadio, Object.assign({}, { onChange, name, value, checked, label, alignment, children }),
        React.createElement("div", { className: `radio__wrapper radio__wrapper-${alignment || 'default'}` },
            React.createElement("label", { className: className, htmlFor: id },
                React.createElement("div", { className: "radio__container" },
                    React.createElement("div", { className: "radio__input-wrapper" },
                        React.createElement("input", { type: "radio", className: "radio__input", value: value, id: id, name: name, onChange: handler, checked: checked }),
                        React.createElement("div", { className: "radio__button" })),
                    React.createElement("div", { className: "radio__label" }, label || '')),
                React.createElement("div", { className: "radio__children" }, children))));
};
//# sourceMappingURL=FormRadio.js.map